interface DynamicDependencyInjector {
    [service: string]: any
}

export type DIService = () => any;

export class DependencyInjector implements DynamicDependencyInjector {

    protected factories: Map<string, DIService> = new Map();
    protected cache: Map<string, any> = new Map();

    set(name: string, object: any): this {

        this.cache.set(name, object);
        this.registerProperty(name);

        return this;
    }

    factory(name, factory) {

        this.factories.set(name, factory);
        this.registerProperty(name);
    }

    get(name: string): any {

        if(this.cache.has(name)){
            return this.cache.get(name);
        }

        let instance = null;

        if(this.factories.has(name)){

            const factory = this.factories.get(name)
            instance = factory();
        }

        if(instance !== null){
            this.cache.set(name, instance);
        }

        return instance;
    }

    protected registerProperty(name) {

        Object.defineProperty(this, name, {
            get: function() {
                return this.get(name);
            }
        });
    }
}